<template>
    <div class="langSelector">
        <div class="flag" :class="currentLang == lang ? 'active' : ''" v-for='lang in this.$i18n.availableLocales' :key="lang" @click="setLang(lang)">
            <v-img :src="require('../assets/'+ lang +'.svg')" alt="" max-height="25" max-width="25"/>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LangSelector',
    data: () => ({

    }),
    computed: {
        currentLang: {
            get () {
                return this.$store.state.lang
            },
            set (value) {
                this.$store.dispatch('setLang', value)
            }
        },
    },
    methods: {
        setLang(lang) {
            this.currentLang = lang;
        }
    },
}
</script>
<style lang="scss">
    .langSelector {
        display:flex;
        justify-content: space-around;
        .flag {
            padding:5px;
            &.active {
                border-radius:5px;
                background-color: #ffd9de;
            }
        }
        .v-input__icon {
            width:70px;
        }
    }
</style>